var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar flex align-center",class:_vm.notificationTypeClass},[_c('div',{staticClass:"admin-icons"}),_c('p',[_vm._v(" "+_vm._s(_vm.notification.message)+" ")]),_c('span',{staticClass:"close-icon",on:{"click":function($event){return _vm.removeNotification(_vm.notification)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }